<template>
    <Panel title="高级选项" collapse>
        <el-form :model="value" label-position="top">
            <el-row>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="代理服务器地址" prop='proxyhost'>
                        <el-input v-model="value.proxyhost"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="代理服务器端口号" prop='proxyport'>
                        <el-input v-model="value.proxyport"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="代理服务器用户名" prop='proxyusername'>
                        <el-input v-model="value.proxyusername"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="代理服务器密码" prop='proxypassword'>
                        <el-input v-model="value.proxypassword"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="连接超时时间" prop='timeout'>
                        <el-input v-model="value.timeout"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </Panel>
</template>
<script>
export default {
    // proxyhost: "",
    // proxyport: "",
    // proxyusername: "",
    // proxypassword: "",
    // timeout: "30"
    props: {
        value: {type: Object, default: () => ({})},
        init: Boolean
    },
    data() {
        return {};
    },
    mounted() {
        if (this.init) {
            this.$set(this.value, 'timeout', '30');
        }
    },
    methods: {
        validate() {
            return Promise.resolve();
        }
    }
};
</script>


